import React, { useContext, createContext } from "react";
import { useDispatch } from "react-redux";
import api from "services/api";
import auth from "services/auth";
import ls from "services/ls";
import { updateUserBalance } from "../stores/balance/userBalance";
import { setIsAuthenticated } from "../stores/auth/userAuth";
import { updateLoginBonus } from "../stores/bonus/loginBonus";

const AppContext = createContext();

function AppProvider({ children }) {
  const dispatch = useDispatch();

  const getUserBalance = async () => {
    const response = await api.get("/get-balance");
    if (response?.status === 200 && response?.data) {
      ls.set("conversionRates", response.data.rates);
      dispatch(updateUserBalance(response.data));
    }
    return response;
  };

  const updateUserAuthStatus = async () => {
    const authenticated = await auth.isAuthenticated();
    dispatch(setIsAuthenticated(!!authenticated));

    if (!authenticated) {
      const emptyBonus = { sc: 0, gc: 0 };
      dispatch(updateLoginBonus(emptyBonus));
      ls.set("loginBonusData", emptyBonus);
    }
  };

  const setLoginBonus = async (bonusData) => {
    if (bonusData) {
      ls.set("loginBonusData", bonusData);
    } else {
      bonusData = ls.get("loginBonusData") || { sc: 0, gc: 0 };
    }
    dispatch(updateLoginBonus(bonusData));
  };

  const updateUserObj = async () => {
    await updateUserAuthStatus();
  };

  React.useEffect(() => {
    const pingPresence = async () => {
      const authenticated = await auth.isAuthenticated();
      if (authenticated) {
        try {
          await api.post("/presence/ping");
        } catch (error) {}
      }
    };

    pingPresence();
    const interval = setInterval(() => {
      pingPresence();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <AppContext.Provider
      value={{
        getUserBalance,
        updateUserAuthStatus,
        setLoginBonus,
        updateUserObj,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
}

export default AppContext;
export { AppProvider, useAppContext };
